<template>
    <div :class="isShowBaiduMap?'showMap':'noShowMap'">
        <div class="x-my16 map-box"
            v-if="(xy.length == 2 && refMap) || isShowBaiduMap">
            <div id="schoolMap" v-if="isShowBaiduMap"></div>
            <div id="imgMap" v-if="refMap && !isShowBaiduMap">
                <img :alt="props.data.data.attributes.name+'地图'"  class="map" :src="myUtils.getUrlPic(refMap, 's')" />
            </div>
            <div class="title">
                <p class="school" v-if="isShowBaiduMap"><img  alt="坐标图标" :src="map100" /><span class="x-ml10">{{ props.data.data.attributes.name }}</span></p>
                <p v-if="aColleges.length > 0" class="">学校附近大学:</p>
            </div>
            <ul>
                <li v-for="item in aColleges" class="clear">
                    <span><img alt="坐标图标"  :src="item.img" /></span><span class="x-ml10">{{ `${item.name}(${item.english})` }}</span>
                    <span class="distance">{{ item.distance }}公里</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import qs from 'qs';
import md5 from "md5";

import map100 from "/assets/img/map_100.png"
import map1 from "/assets/img/map_1.png"
import map2 from "/assets/img/map_2.png"
import map3 from "/assets/img/map_3.png"
import map4 from "/assets/img/map_4.png"
import map5 from "/assets/img/map_5.png"
import map6 from "/assets/img/map_6.png"
import map7 from "/assets/img/map_7.png"
import map8 from "/assets/img/map_8.png"
import map9 from "/assets/img/map_9.png"
import map10 from "/assets/img/map_10.png"

const props = defineProps({
    data: Object
})
let location = props.data.data.attributes.location || "";
console.log('current location is', location);
//测试
// location = '-0.122988,51.516147';
const xy = location.split(',');


let isShowBaiduMap = false;
if (/map$/.test(useRoute().path)) {
    isShowBaiduMap = true;
}

function loadJScript() {
    // var script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = '//api.map.baidu.com/api?type=webgl&v=1.0&ak=yWp4PKouEguD3HOdxFAzr8GzdhkaKojp&callback=init';
    // document.body.appendChild(script);
    const script = document.createElement('script');
    //使用个人账号：小鸥游四海   手机号：18629579853  联系人：Rick
    script.src = '//api.map.baidu.com/api?type=webgl&v=1.0&ak=dSu0NcGeFmn98ySTddkCFfp99UR0MDM0&callback=init'; // 外部脚本的 URL
    script.async = true; // 设置为 true 以异步加载脚本
    script.onload = () => {
        // 脚本加载完成后执行的回调函数
        console.log('External script loaded successfully');
        // 如果脚本提供了初始化函数，可以在这里调用
        // 例如：externalScriptInit();
    };
    script.onerror = () => {
        // 脚本加载失败时执行的回调函数
        console.error('Failed to load the external script');
    };
    document.head.appendChild(script);
}
let refMap = ref(props.data.data.attributes.map.data);
function init() {
    //如果有地图，则显示地图
    var map = new BMapGL.Map('schoolMap'); // 创建Map实例
    var point = new BMapGL.Point(xy[0], xy[1]); // 创建点坐标
    map.centerAndZoom(point, 14);
    map.enableScrollWheelZoom(); // 启用滚轮放大缩小
    var icon = new BMapGL.Icon(map100, new BMapGL.Size(26, 40));
    var marker = new BMapGL.Marker(point, {
        icon: icon
    });
    map.addOverlay(marker);



    // var marker1 = new BMapGL.Marker(new BMapGL.Point(-0.122988, 51.51693));
    // var marker2 = new BMapGL.Marker(new BMapGL.Point(-0.122988, 51.51652));
    // var marker3 = new BMapGL.Marker(new BMapGL.Point(-0.122988, 51.516147));
    // var marker4 = new BMapGL.Marker(new BMapGL.Point(116.415, 39.931));
    // // 在地图上添加点标记
    // map.addOverlay(marker2);
    // map.addOverlay(marker3);
    // map.addOverlay(marker4);


    var opts = {
        position: point, // 指定文本标注所在的地理位置
        offset: new BMapGL.Size(14, -20) // 设置文本偏移量
    };
    // 创建文本标注对象
    var label = new BMapGL.Label(props.data.data.attributes.name, opts);
    // 自定义文本标注样式
    label.setStyle({
        color: 'black',
        borderRadius: '5px',
        borderColor: '#ccc',
        padding: '6px',
        fontSize: '12px',
        // height: '30px',
        // lineHeight: '30px',
        // fontFamily: '微软雅黑'
    });
    // map.addOverlay(label);


    loadColleges(map);
}
onMounted(() => {
    if (xy.length == 2) {
        window.md5 = md5;
        window.init = init;
        if (isShowBaiduMap) {
            loadJScript();
            //读地图
        } else {
            //直接读附近大学
            loadColleges();
        }

    }


})

const loadColleges = async (map) => {
    // const { id } = useRoute().params;
    // const sId = id.split('-')[0];
    const sId = props.data.data.attributes.id
    const query = qs.stringify({
        fields: ['name', 'english', 'location'],
    })
    const url = '/api/fw/college-locations/?' + query;
    console.log('url', url);
    const { data } = await $fetch(url);
    let location;
    let aL;
    let ndistance;
    console.log('data', data);
    let aNear = [];
    data?.forEach(element => {
        location = element.attributes.location;
        aL = location.split(',');
        ndistance = getDistance(aL[0], aL[1], xy[0], xy[1]);
        if (ndistance < 5000) {
            console.log('ndistance <5000', element.attributes.name)
            // addNearCollege(map, aL[0], aL[1], index, ndistance,element);
            aNear.push({
                x: aL[0],
                y: aL[1],
                distance: ndistance,
                element: element
            });
        }
    });
    if (aNear.length > 0) {
        aNear.sort((a, b) => {
            if (a.distance > b.distance) {
                return 1;
            } else if (a.distance < b.distance) {
                return -1;
            } else {
                return 0;
            }
        });
        aNear.forEach((element, index) => {
            if (index > 9) {
                return false; //最多显示10个
            }
            addNearCollege(map, element.x, element.y, index, element.distance, element.element)
        });
    }

}
const imgs = [
    map1,
    map2,
    map3,
    map4,
    map5,
    map6,
    map7,
    map8,
    map9,
    map10
];
const aColleges = ref([]);
function addNearCollege(map, x, y, index, distance, college) {


    aColleges.value.push({
        img: imgs[index],
        name: college.attributes.name,
        english: college.attributes.english,
        distance: parseFloat((distance / 1000).toFixed(1))
    });

    if (isShowBaiduMap) {
        var point = new BMapGL.Point(x, y); // 创建点坐标
        var icon = new BMapGL.Icon(imgs[index], new BMapGL.Size(21, 32));
        var marker = new BMapGL.Marker(point, {
            icon: icon
        });
        map.addOverlay(marker);
    }
}

function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371000; // 地球半径，单位：米
    const toRadians = (degree) => degree * (Math.PI / 180);

    const lat1Rad = toRadians(lat1);
    const lon1Rad = toRadians(lon1);
    const lat2Rad = toRadians(lat2);
    const lon2Rad = toRadians(lon2);

    const dLat = lat2Rad - lat1Rad;
    const dLon = lon2Rad - lon1Rad;

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1Rad) * Math.cos(lat2Rad) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = R * c;
    return distance;
}

</script>

<style scoped>
#schoolMap {
    width: 100%;
    height: 300px;
}

.distance {
    margin-left: 150px;
    float: right;
}
.noShowMap #imgMap{
    overflow:hidden;
}
.noShowMap #imgMap .map{
    max-width:102%;
    margin-left:-1%;
    margin-top:-2px;
}
.noShowMap .map-box{
    border: 1px solid #ccc;
}
.map-box {}

li {
    list-style: none;
    margin: 10px 16px;
}

li img {
    margin: 0
}

.title {
    margin-top: 8px;
    /* border-bottom:1px solid #ccc; */
    padding: 8px 16px;
    font-weight: bold;
}

.map {
    margin: 0;
    border-radius: 0;
}
</style>
